// reducers.js
import { combineReducers } from "redux";
import activityLogReducer from "./activityLogReducer";
import regionReducer from "./regionReducer";
import authReducer from "./authReducer";
import accountReducer from "./accountReducer";
import roleReducer from "./roleReducer";
import satuanKerjaReducer from "./satuanKerjaReducer";
import permissionReducer from "./permissionReducer";
import pegawaiReducer from "./pegawaiReducer";
import customerReducer from "./customerReducer";
import supplierReducer from "./supplierReducer";
import productReducer from "./productReducer";
import productGroupReducer from "./productGroupReducer";
import materialReducer from "./materialReducer";
import saleReducer from "./saleReducer";
import purchaseReducer from "./purchaseReducer";
import reportReducer from "./reportReducer";
import dashboardReducer from "./dashboardReducer";
import unitReducer from "./unitReducer";
import categoryReducer from "./categoryReducer";
import categoryTypeReducer from "./categoryTypeReducer";
import stockOpnameReducer from "./stockOpnameReducer";
import storeReducer from "./storeReducer";
import cashierShiftReducer from "./cashierShiftReducer";
import inventoryInsightReducer from "./inventoryInsightReducer";
import stockReportReducer from "./stockReportReducer";
import stockHistoryReducer from "./stockHistoryReducer";
import stockTransferReducer from "./stockTransferReducer";
import sellerStockReducer from "./sellerStockReducer";
import cashBankReducer from "./cashBankReducer";
import operationalExpenseReducer from "./operationalExpenseReducer";
import fixedAssetReducer from "./fixedAssetReducer";

const rootReducer = combineReducers({
  activityLogs: activityLogReducer,
  regions: regionReducer,
  auth: authReducer,
  accounts: accountReducer,
  roles: roleReducer,
  permissions: permissionReducer,
  satuanKerjas: satuanKerjaReducer,
  pegawais: pegawaiReducer,
  customers: customerReducer,
  suppliers: supplierReducer,
  products: productReducer,
  productGroups: productGroupReducer,
  materials: materialReducer,
  sales: saleReducer,
  purchases: purchaseReducer,
  reports: reportReducer,
  dashboard: dashboardReducer,
  units: unitReducer,
  categories: categoryReducer,
  categoryTypes: categoryTypeReducer,
  stockOpnames: stockOpnameReducer,
  stores: storeReducer,
  cashierShifts: cashierShiftReducer,
  inventoryInsights: inventoryInsightReducer,
  stockReports: stockReportReducer,
  stockHistories: stockHistoryReducer,
  stockTransfers: stockTransferReducer,
  sellerStocks: sellerStockReducer,
  cashBank: cashBankReducer,
  operationalExpenses: operationalExpenseReducer,
  fixedAssets: fixedAssetReducer,
});

export default rootReducer;
